import { useState, useEffect } from "react";
import styles from "../../assets/css/module/common.module.css";
import { IsNotNull, getFormattedNumber, INNRD } from '../../helpers/common/helper';
import { CheckCircleFill } from 'react-bootstrap-icons';

const FnBList = (props) => {
  const [img, setImg] = useState(null);
  const [s_selected, setS_Selected] = useState('');
  const [isMounted, setIsMounted] = useState(false)

  function select(x) {
    if (props.qty > 0) {
      let rs = { icon: '', value_p: null }
      if (IsNotNull(props.selectedMenu)) {
        if (props.selectedMenu.fnb_id !== x.fnb_id) {
          rs = { icon: 'checklist-active', value_p: x }
        } else {
          rs = { icon: '', value_p: null }
        }
      } else {
        rs = { icon: 'checklist-active', value_p: x }
      }
      setS_Selected(rs.icon)
      props.setter(rs.value_p)
    }
  }

  useEffect(() => {
    if (IsNotNull(props)) {
      if (!isMounted) {
        if (IsNotNull(props.obj)) {
          if (IsNotNull(props.obj.fnb_file_details)) {
            setImg(IsNotNull(props.obj.fnb_file_details.url) ? props.obj.fnb_file_details.url : '')
          }
        }

        setIsMounted(true)
      }
    }
  }, [isMounted,props])

  return (
    <div className={`${styles['fnb-list-container']} `} onClick={() => select(props.obj)}>
      <img src={img} alt="fnb" className={`${styles['fnb-list-content-img']}`} />

      <div className={`${styles['fnb-list-content-detail']}`}>
        <div>
          <div className={`${styles['fnb-list-content-title']} ${styles['txt-of-elps']}`}>
            {props.title}
          </div>
          <div className={`${styles['fnb-list-content-desc']} ${styles['txt-of-elps']}`}>
            {props.desc}
          </div>
        </div>


        <div className={`${styles['fnb-list-content-total']} `}>
          <div className={`${styles['fnb-list-qty-amount']} ${styles[props.qty > 5 ? 'safe-stock' : parseInt(props.qty) === 0 ? 'empty-stock' : 'low-stock']}`}>
            {`${getFormattedNumber(INNRD(props.qty, 0), '.', ',')}`}
          </div>
        </div>
      </div>

      {
        IsNotNull(props.selectedMenu) ? props.obj.fnb_id === props.selectedMenu.fnb_id ?
          <div className={`${styles['menu-isSelected-container']} ${styles[s_selected]}`}>
            <CheckCircleFill className={`${styles['menu-isSelected']} `} />
          </div> : null : null
      }

    </div>
  )
}

export default FnBList;